/* global Quill, Metafans_JS */

/**
 * Initializes the bbPress Quill editor and its submission handling.
 */
export function init() {
    let quillEditor;

    if (jQuery("#th_bbp_reply").length) {
        quillEditor = new Quill("#th_bbp_reply", {
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline"],
                    ["link", "image"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["clean"],
                ],
            },
            placeholder: "Your topic description...",
            theme: "snow", // or 'bubble'
        });

        const insertToEditor = (url) => {
            const range = quillEditor.getSelection();
            quillEditor.insertEmbed(range.index, "image", url);
        };

        const selectLocalImage = () => {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            input.click();

            input.onchange = async () => {
                const file = input.files[0];
                if (/^image\//.test(file.type)) {
                    const formData = new FormData();
                    formData.append("file", file);
                    formData.append("action", "upload_quill_image"); // WordPress AJAX hook

                    const response = await fetch("/wp-admin/admin-ajax.php", {
                        method: "POST",
                        body: formData,
                    });

                    const json = await response.json();
                    if (json.success && json.data.url) {
                        insertToEditor(json.data.url);
                    }
                }
            };
        };

        quillEditor.getModule("toolbar").addHandler("image", () => {
            selectLocalImage();
        });
    }

    // BBPRESS submit reply ajax
    jQuery(document).on("click", "#th_bbp_reply_submit", function (e) {
        e.preventDefault();
        const that = jQuery(this);

        // Guard-close/bailout if editor is not initialized or is blank
        if (!quillEditor || !quillEditor.getText().trim()) return;

        that.text("Please Wait...");
        that.attr("disabled", true);
        const data = jQuery(".th-bbpress-reply-form").serializeArray();
        const text = quillEditor.root.innerHTML; // Use innerHTML to preserve formatting
        data.push({ name: "bbp_reply_content", value: text });

        const newData = {};
        data.forEach(item => {
            newData[item.name] = item.value;
        });

        jQuery.ajax({
            url: Metafans_JS.ajaxurl,
            type: "POST",
            data: {
                action: "th_bbp_new_reply",
                data: newData,
            },
            success: function (res) {
                if (res.errors) {
                    jQuery(".th_bpp_reply_messages").html('<span class="errors">' + res.errors.toString() + "</span>");
                    that.attr("disabled", false);
                } else {
                    jQuery(".th_bpp_reply_messages").html('<span class="success">' + res.success["text"] + "</span>");
                    window.location.href = res.success["goto"];
                }
                that.text("Submit");
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.error(xhr);
                that.text("Submit");
                that.attr("disabled", false);
            },
        });
    });
}